import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=34f86aff&scoped=true"
import script from "./SnackbarComponent.vue?vue&type=script&lang=js"
export * from "./SnackbarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f86aff",
  null
  
)

export default component.exports